import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../utl/models/Visiable";
import { AllState } from "../models/AllState";

const setLocationFilterActive = (state: AllState, action: PayloadAction<Visiable>) => {
    state.isLocationsFilterActive = action.payload.visiable;
}

export default setLocationFilterActive;